import React from "react";
// Import Link
import { Link } from "react-router-dom";
// import Img
import Img from "../../../src/assets/img/airplane.png";

const ReligiousTravelText = () => {
  return (
    <>
      <section id="about_us_top" className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="about_us_left">
                {/* <h5>About us</h5> */}
                <h2>Religious Travel</h2>
                <p>
                Religious travel holds profound significance, and at House of Polani, we approach these sacred journeys with the utmost respect and dedication. Our specialized religious travel services focus on creating peaceful, well-organized experiences that allow pilgrims to focus entirely on their spiritual journey. We understand the deep meaning these trips hold and ensure every detail is handled with appropriate care and consideration.
                </p>
                <p>
                Our Hajj services encompass everything needed for this significant pilgrimage. From securing accommodations near the Haram to providing dedicated religious guides, we ensure pilgrims can perform their rituals with peace of mind. Our packages include all necessary arrangements, from transportation and accommodation to meals and medical support, allowing pilgrims to focus solely on their spiritual experience.
                </p>
                <p>
                For Umrah travelers, we offer year-round services that cater to individuals, families, and groups. Our arrangements include carefully selected accommodations, reliable transportation, and experienced guides who assist with religious rituals. The same level of comprehensive care extends to our Ziarat packages, where we arrange visits to significant religious sites with knowledgeable guides who enhance the spiritual experience with their insights.
                {" "}
                </p>
                {/* <Link to="#!" className="btn btn_theme btn_sm">
                  More
                </Link> */}
              </div>
            </div>
            {/* <div className="col-lg-6">
              <div className="about_us_right">
                <img src={Img} />
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default ReligiousTravelText;
